'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/icons-react.production.js');
} else {
  module.exports = require('./dist/icons-react.development.js');
}
